import React from 'react';


export default class ManualAddress extends React.Component {
    render() {
        const { incomplete, showError, editAddress, clearAddress, manualLabel, addAddressLabel, invalidAddressCity } = this.props;
        return (
            <div className="relative saved-address-container">
                <label className={`input-label ${((incomplete && showError) || invalidAddressCity) ? "error-label" : ""}`}>Saved Address
                    {!!addAddressLabel && addAddressLabel}
                    <span className="link-text small-text" onClick={editAddress}>Edit</span>
                    <span className="link-text small-text" onClick={clearAddress}>Clear</span>
                </label>
                <label className="saved-address">{manualLabel}</label>
                {incomplete && showError && !invalidAddressCity && <span className="error-label">Incomplete manual address. Missing street number, street, city, or country.</span>}
                {invalidAddressCity && <span className="error-label">Invalid address, city must be included in campaign's location group.</span>}
            </div>
        );
    }
}
//clearAddress, editAddress, manual Label, incomplete, showError


// WEBPACK FOOTER //
// ./src/components/commonComponents/shared/ManualAddress.jsx